(function() {

  'use strict';

  function UploadService($q, UploadResource) {

    UploadService.proccessFile = function(config, callback) {

      if(config['s3FileNameId'].endsWith('xml')){
        return UploadResource.proccessXMLFile(config).$promise;
      } else {
        return UploadResource.proccessFile(config).$promise;
      }
    };

    UploadService.proccessFileAsync = function(config) {

      if(config['s3FileNameId'].endsWith('xml')){
        return UploadResource.proccessXMLFileAsync(config).$promise;
      } else {
        return UploadResource.proccessFileAsync(config).$promise;
      }
    };

    UploadService.listarJobs = function() {
      return UploadResource.listarJobs().$promise;
    };

    return UploadService;

  }

  angular
    .module('mandaeApp')
    .factory('UploadService', UploadService);

})();
